<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Migração de Cartões OTP</strong>
        </div>
        <b-form @submit.stop.prevent>
          <b-form-group label="Ambiente de Origem" label-for="provider-from">
            <b-form-select v-model="params.providerFrom" id="provider-from">
              <option value="vault">Vault</option>
              <option value="bird">Bird</option>
            </b-form-select>
          </b-form-group>
          
          <b-form-group label="Ambiente de Destino" label-for="provider-to">
            <b-form-select v-model="params.providerTo" id="provider-to">
              <option value="vault">Vault</option>
              <option value="bird">Bird</option>
            </b-form-select>
          </b-form-group>
          
          <b-form-group label="Números seriais" label-for="serial-numbers">
            <b-form-textarea id="serial-numbers" v-model="params.serialNumbersStr" rows="3"></b-form-textarea>
          </b-form-group>

          <div v-if="serialNumbersNotMigrated.length">
            <b-alert show variant="warning"><strong>Não migrados:</strong> 
            <span v-for="itm in serialNumbersNotMigrated" :key="itm.serial" v-b-tooltip.hover :title="itm.message">
              {{ itm.serial }}
            </span>
            </b-alert>
          </div>

          <div v-if="serialNumbersNotFound.length">
            <b-alert show variant="warning"><strong>Não encontrados:</strong> {{ serialNumbersNotFound.join(", ") }}</b-alert>
          </div>

          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="success" @click="migrate"><i class="fa fa-exchange"></i> Migrar</b-button>&nbsp;
              </b-col>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="primary" @click="verify"><i class="fa fa-search"></i> Verificar</b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Atraso de Cartão OTP</strong>
        </div>
        <b-row>
          <b-col sm="12">
            <div class="alert alert-secondary" role="alert">
              Adicione 3 OTPs do seu cartão para calcular o atraso a ser informado na importação.<br>
              <strong>Importante:</strong> Só clique em adicionar quando visor apagar.
            </div>
          </b-col>
        </b-row>
        <b-form @submit.stop.prevent>
          <b-form-group label="Semente do cartão" label-for="device-seed">
            <div class="input-group input-group-sm">
              <b-form-input v-model="offsetFind.seed" id="device-seed"></b-form-input>
            </div>
          </b-form-group>
          <b-form-group label="Dias para calcular" label-for="days-to-find">
            <div class="input-group input-group-sm">
              <b-form-input type="number" v-model="offsetFind.days" id="days-to-find"></b-form-input>
            </div>
          </b-form-group>
          <b-form-group label="Janela do cartão" label-for="card-window">
            <div class="input-group input-group-sm">
              <b-form-input type="number" v-model="offsetFind.window" id="card-window"></b-form-input>
            </div>
          </b-form-group>
          <b-form-group label="Otp do cartão" label-for="device-otp">
            <div class="input-group input-group-sm">
              <b-form-input v-model="offsetFind.otp" id="device-otp"></b-form-input>
              <span class="input-group-append">
                <button id="btn-add-otp" class="btn btn-success" type="button" @click="addOtp" :disabled="offsetFind.calculating" @click.stop.prevent><i class="fa fa-plus"></i> &nbsp; Adicionar</button>
              </span>
            </div>
          </b-form-group>
          <div v-if="offsetFind.otps.length">
            <b-alert show variant="secondary"><strong>OTPs informados:</strong> 
            <span v-for="itm in offsetFind.otps" :key="itm.timestamp">
              {{ itm.otp }}
            </span>
            </b-alert>
          </div>
          <div>
            <b-alert v-if="offsetFind.offset" show variant="success">Offset encontrado: <strong>{{ offsetFind.offset }}</strong> segundos</b-alert>
            <b-alert v-if="offsetFind.calculating" show variant="primary">Calculando offset...</b-alert>
            <b-alert  v-if="offsetFind.notFound && !offsetFind.otps.length" show variant="danger">Offset não encontrado!</b-alert>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { TOTP, Secret } from 'otpauth';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      params: {
        providerFrom: null,
        providerTo: null,
        serialNumbersStr: ""
      },
      serialNumbersNotMigrated: [],
      serialNumbersNotFound: [],
      loadCount: 0,
      offsetFind: {
        otp: null,
        seed: null,
        days: 1,
        window: 60,
        otps: [],
        offset: null,
        calculating: false,
        notFound: false,
      }
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    migrate() {
      let _this = this;
      this.loadCount++;
      this.params.serialNumbers = this.params.serialNumbersStr.split(/[\s,]+/);
      this.serialNumbersNotMigrated = [];
      this.serialNumbersNotFound = [];
      axios
        .post(`${env.urlBillingApi}/migrate-otp-device`, this.params)
        .then(function(response) {
          let serialNumbersMigrated = response.data.migrated.map((itm) => itm.toString());
          let serialNumbersReturned = serialNumbersMigrated.concat(Object.keys(response.data.errors));
          _this.serialNumbersNotMigrated = Object.keys(response.data.errors).map((itm) => { 
            return { 
              serial: itm.toString(), 
              message: response.data.errors[itm] 
            }
          });
          _this.params.serialNumbers.forEach(serial => {
            if (!serialNumbersReturned.includes(serial)) {
              _this.serialNumbersNotMigrated.push({serial, message: 'Não encontrado'});
            }
          });
          if (serialNumbersMigrated.length > 0) {
            _this.$bvModal.msgBoxOk(serialNumbersMigrated.length + ' cartões migrados com sucesso!')
              .then(value => {})
              .catch(console.error);
          } else {
            _this.$bvModal.msgBoxOk('Nenhum cartão foi migrado!')
              .then(value => {})
              .catch(console.error);
          }
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    verify() {
      let _this = this;
      this.loadCount++;
      this.serialNumbersNotMigrated = [];
      this.serialNumbersNotFound = [];
      let serialNumbers = this.params.serialNumbersStr.trim().split(/[\s,]+/);
      axios
        .get(`${env.urlBillingApi}/migrate-otp-device?providerFrom=${this.params.providerFrom}&serialNumbers=${serialNumbers.join(" ")}`)
        .then(function(response) {
          let serialNumbersExported = Object.values(response.data).map((itm) => itm.toString());
          serialNumbers.forEach(sn => {
            if (!serialNumbersExported.includes(sn)) {
              _this.serialNumbersNotFound.push(sn);
            }
          });
          if (_this.serialNumbersNotFound.length == 0) {
            _this.$bvModal.msgBoxOk(`Todos números seriais informados estão no ambiente ${_this.params.providerFrom}!`)
              .then(value => {})
              .catch(console.error);
          }
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    addOtp() {
      if (!this.offsetFind.seed) {
        return alert("Informe a semente do cartão.");
      }
      if (!this.offsetFind.otp || this.offsetFind.otp.length != 6) {
        return alert("Informe um OTP válido.");
      }
      this.offsetFind.otps.push({
        timestamp: Date.now(),
        otp: this.offsetFind.otp
      })
      this.offsetFind.otp = "";
      if (this.offsetFind.otps.length == 3) {
        this.offsetFind.calculating = true;
        this.findOtpDelta().then((offsetTime) => {
          this.offsetFind.offset = offsetTime;
          this.offsetFind.notFound = !offsetTime;
          this.offsetFind.otps = [];
        }).catch((err) => {
          console.error(err);
          alert("Erro ao procurar atraso.")
        }).finally(() => {
          this.offsetFind.calculating = false;
        })
      }
    },
    /**
     * Calculate OTP
     * 
     * @param {number} now Timestamp to calculate otp
     * @param {number} offsetTime offset time in seconds to calculate
     * @returns 
     */
    calculateOtp(now, offsetTime = 0) {
      return new TOTP({ 
        secret: Secret.fromHex(this.offsetFind.seed),
        period: this.offsetFind.window
      }).generate({
        timestamp: now + offsetTime * 1000
      });
    },

    nextTick() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 0)
      })
    },

    isSameOtpList(arr1, arr2) {
      if (arr1.length != arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] != arr2[i]) {
          return false
        }
      }
      return true
    },

    async findOtpDelta() {
      let lastOtpTime = this.offsetFind.otps[1].timestamp;
      let cardOtps = this.offsetFind.otps.map(itm => itm.otp);
      let offset = Math.floor(this.offsetFind.days * 86400 / this.offsetFind.window) // Convert in seconds salt each Xs
      let otpMem = []
      let otpMemN = []
      for (let i = 0; i <= offset; i++) {
        let offsetTime = this.offsetFind.window * i
        let lengthOtpArr = cardOtps.length;
        let otp = this.calculateOtp(lastOtpTime, offsetTime)
        otpMem.push(otp)
        let otpn = this.calculateOtp(lastOtpTime, -offsetTime)
        otpMemN.unshift(otpn)

        if (otpMem.length == lengthOtpArr) {
          console.log(`OTP: ${otpMem}, OffsetTime: ${offsetTime}, Date: ${new Date(lastOtpTime + (offsetTime * 1000)).toISOString()}`)
          console.log(`OTP: ${otpMemN}, OffsetTime: ${-offsetTime}, Date: ${new Date(lastOtpTime + (-offsetTime * 1000)).toISOString()}`)
        }

        if (this.isSameOtpList(otpMem, cardOtps) || this.isSameOtpList(otpMemN, cardOtps)) {
          console.log('>>>>>> \\o/ <<<<<<')
          offsetTime = this.isSameOtpList(otpMem, cardOtps) ? offsetTime : -offsetTime
          if (offsetTime < 0) {
            offsetTime = offsetTime + this.offsetFind.window * 2;
          }
          offsetTime += this.syncOtpSeconds(offsetTime, lastOtpTime)
          console.log('OffsetTime:', offsetTime)
          console.log('Date Now:', new Date(lastOtpTime).toISOString())
          console.log('Date Card:', new Date(lastOtpTime + (offsetTime * 1000)).toISOString())
          return -offsetTime
        }
        otpMem.length == lengthOtpArr && (otpMem.shift())
        otpMemN.length == lengthOtpArr && (otpMemN.pop())
        await this.nextTick()
      }
      return null;
    },

    syncOtpSeconds(offset, now) {
      let oldInc = 0;
      for (let i = 0; i < 61; i++) {
        let otp1 = this.calculateOtp(now, offset)
        let inc = offset < 0 ? -i : i
        let otp2 = this.calculateOtp(now, offset + inc)
        if (otp1 != otp2) {
          return oldInc
        }
        oldInc = inc
      }
      return 0
    }
  }
}
</script>
